// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_5SrQQ","visual":"index_visual_1nlUw","catch":"index_catch_26al-","bgYellowStripe":"index_bgYellowStripe_I56Of"};